import { adminStoreActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

export function organizationCases(builder: ActionReducerMapBuilder<NotificationState>) {
  builder
    .addCase(
      adminStoreActions.organization.update.fulfilled,
      (state, { payload: { organization } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: organization.name },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      adminStoreActions.organization.updateStructuredDataSchema.fulfilled,
      (state, { payload: { organization } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: organization.name },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      adminStoreActions.organization.updateStructuredDataDisplay.fulfilled,
      (state, { payload: { organization } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: organization.name },
          icon: 'check',
          id: generateId(),
        })
      },
    )
}
